export default "__VITE_ASSET__DFtjFT59__"